<template>
  <div>
    <div class="dash-header">
      <div class="dash-header-inner">
        <div class="welcome flexItem">
          <template>
            <router-link to="/" class="dash-head-logo">
              <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/logo.png" />
            </router-link>
          </template>
          <div class="ResMenu" v-if="oWidth <= 750" :class="{ 'on': isShow }" @click="menuClick">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="searchDiv" v-if="!$config.settings.onlayReg">
            <div class="theme-color" :class="oWidth <= 750 ? '' : 'flex'">
              <div class="mb8 font-size-14" style="margin-right: 90px;">
                <i class="el-icon-time" style="margin-right: 3px;"></i>{{ $t('开展时间英文') }}
              </div>
              <div class="mb8 font-size-14">
                <i class="el-icon-location-outline" style="margin-right: 3px;"></i>{{ $t('开展地点英文') }}
              </div>
            </div>
          </div>
        </div>

        <div class="welcome">
          <template v-if="$store.state.config.hideElement">
            <template v-if="isLogin">
              <span class="font-size-14">{{ name || loginAccount || '--' }}</span>
              <a href="javascript:void(0)" @click="LogOut" class="font-size-16">{{ $t('logout') }}</a>
            </template>
            <span v-else class="link Link font-size-16" @click="goLogin" :class="{ 'login_link_en': language == 'en' }">
              <span class='login-iconfont iconfont icon92act_zhucedenglu'></span>
              {{ $t('registerLogin') }}
            </span>
          </template>
          <div class='el-menu-iconfont language-change' v-if="false">
            <i class="iconfont iconicon_A" @click="setLang('en')" v-if="language === 'zh'"></i>
            <i class="iconfont iconyuyanqiehuancon" @click="setLang('zh')" v-if="language === 'en'"></i>
          </div>
        </div>
      </div>
    </div>
    <advertisementVertical :option="$config.advertisement.leftList.workList" :leftPosition='true'
      :top="advertisementTop+'px'"></advertisementVertical>
    <advertisementVertical :option="$config.advertisement.rightList.workList" :rightPosition='true'
      :top="advertisementTop+'px'"></advertisementVertical>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import advertisementVertical from '@/components/advertisementVertical'

export default {
  name: 'DashHeader',
  components: {
    advertisementVertical
  },
  data() {
    return {
      advertisementTop: 98,
      activeIndex: '/invite',
      oWidth: document.body.clientWidth,
      name: ''
    }
  },
  computed: {
    ...mapGetters(['language', 'isLogin', 'info', 'subjectType', 'loginAccount'])
  },
  // watch: {
  //   $route: function() {
  //     this.menuActive()
  //   }
  // },
  mounted() {
    if (this.subjectType == 'ACTOR') {
      this.name = this.info.userInfo.name
    } else {
      this.name = this.info.visitor.name
    }
  },
  methods: {
    // 点击菜单选中
    menuActive: function() {
      let path = this.$route.path
      if (this.$route.meta && this.$route.meta.pPath) {
        path = this.$route.meta.pPath
      }
      this.activeIndex = path
    },
    // 语言切换
    setLang(language) {
      this.$i18n.locale = language
      this.$store.commit('SET_LANGUAGE', language)
      location.reload()
    },
    // 退出登录
    async LogOut() {
      await this.$store.dispatch('LogOut').then(() => {
        this.loginSource({replaceStatus: true})
      })
    },
  }
}
</script>
<style lang="stylus">
link-color = $color-main
link-hover = $color-main-hover
.line-mar {
  color: $color-gray-d9 
}

.item .el-badge__content.is-dot{
    top: 9px !important;
    left: -17px !important;
}

.el-menu--horizontal .el-menu-item {
  padding: 0px 16px !important;
}

.login-info{
  display: block;
  margin-top: -2px;

  & > span.head-roles{
    display: block;
    margin-left: 0;
  }

  &.nav-login-info {
    margin-right: 12px;

    * {
      display: inline-block;
      vertical-align top;
    }

    a {
      margin-left: 12px;
      margin-right: 12px;
      color: $color-main;
    }

    & > span.head-roles{
      margin-left: 12px;
      display: inline-block;

      font {
        color: $color-main;
      }
    }
  }
}
.searchDiv
  display: inline-block;
  // margin-left: 24px;
  // width 400px;
  transition: all .3s;
  .el-select .el-input {
      width: 100px;
  }
  .input-with-select .el-input-group__prepend {
      background-color: $color-white;
  }

a
  color link-color
  &:hover
    color link-hover
.dash-header
  position relative
  width 100%
  min-height 80px
  box-shadow 0 1px 10px -2px $box-shadow2
  .external_link
    display block
  .el-icon-arrow-down
    display none
.dash-header-inner
  max-width $container-width
  margin 0 auto
  padding 6px 15px
  height 80px
  display flex
  align-items center
  justify-content space-between
  color $color-black-65
  font-weight 400
  line-height 20px
  .language-change {
    margin-left: 10px;
  }
  .welcome
    font-size 12px
    .dash-head-logo
      display inline-block
      height 40px
      width 245px
      padding:6px 0
      img
        height 100%
    .head-roles
      i 
        font-style initial
      font
        color $color-blue
    *
      margin-right 12px
  nav
    font-size 12px
    display flex
    // display none
    align-items center
    a
      color $color-black-65
    a:hover
      color link-hover
    > a
      display inline-block
      padding 0 12.5px
      text-align center
      position relative
      &:before
        content ''
        position absolute
        right 0
        top 5px
        width 1px
        height 12px
        background $color-black-15
      &:last-child:before
        display none
    .iconfont
      margin-right 0
      margin-left: 0
      padding-top 4px
      width 25px
      font-size 25px
      color $color-main
      cursor pointer
      vertical-align -5px;
</style>
